import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api";
import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";

function CadCliente() {
  const navigate = useNavigate();
  const [listaHistorico, setListaHistorico] = useState([]);

  function FormataData(data) {
    return data
      ? DateTime.fromISO(data).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : "";
  }

  function ListarHistorico() {
    api
      .get("v1/cliente/historico", {
        params: {
          codequipe: localStorage.getItem("tempCodEquipe"),
          codcliente: localStorage.getItem("tempCodCliente"),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then((res) => setListaHistorico(res.data))
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    ListarHistorico();
  }, []);

  return (
    <div className="container-fluid py-3">
      {/* TÍTULO */}
      <div className="row mb-3">
        <div className="col-12">
          <h4 className="fw-bold text-center text-md-start">
            Histórico Financeiro — {localStorage.getItem("tempCliente")}
          </h4>
        </div>
      </div>

      {/* ===== TABELA (DESKTOP / TABLET) ===== */}
      <div className="row d-none d-md-block">
        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-hover table-sm align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Entrega</th>
                  <th>Venc.</th>
                  <th>Tipo</th>
                  <th>Peças</th>
                  <th>Itens</th>
                  <th>Valor</th>
                  <th>Empresa</th>
                  <th>Em Aberto</th>
                  <th>Status</th>
                  <th>Vendedor</th>
                </tr>
              </thead>
              <tbody>
                {listaHistorico.map((item) => (
                  <tr key={item.codcontasreceber}>
                    <td>{item.codcontasreceber}</td>
                    <td>{FormataData(item.dtentragapano)}</td>
                    <td>{FormataData(item.dtvencimento)}</td>
                    <td>{item.tipopano}</td>
                    <td>{item.qtdepeca}</td>
                    <td>{item.qtdeitens}</td>
                    <td>
                      {Number(item.valorpano).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                    <td>
                      {Number(item.valorempresa).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                    <td>
                      {Number(item.valorrestante).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                    <td
                      className={
                        item.status === "PAGO"
                          ? "text-success"
                          : "text-danger"
                      }
                    >
                      {item.status}
                    </td>
                    <td>{item.vendedor}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <small className="text-muted">
            Registros: {listaHistorico.length}
          </small>
        </div>
      </div>

      {/* ===== CARDS (MOBILE) ===== */}
      <div className="row d-block d-md-none">
        <div className="col-12">
          {listaHistorico.map((item) => (
            <div
              key={item.codcontasreceber}
              className="card mb-3 shadow-sm"
            >
              <div className="card-body">
                <div className="d-flex justify-content-between mb-2">
                  <strong>#{item.codcontasreceber}</strong>
                  <span
                    className={
                      item.status === "PAGO"
                        ? "badge bg-success"
                        : "badge bg-danger"
                    }
                  >
                    {item.status}
                  </span>
                </div>

                <div className="mb-1">
                  <strong>Entrega:</strong>{" "}
                  {FormataData(item.dtentragapano)}
                </div>

                <div className="mb-1">
                  <strong>Vencimento:</strong>{" "}
                  {FormataData(item.dtvencimento)}
                </div>

                <div className="mb-1">
                  <strong>Tipo:</strong> {item.tipopano}
                </div>

                <div className="mb-1">
                  <strong>Peças:</strong> {item.qtdepeca} |{" "}
                  <strong>Itens:</strong> {item.qtdeitens}
                </div>

                <div className="mb-1">
                  <strong>Valor:</strong>{" "}
                  {Number(item.valorpano).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </div>

                <div className="mb-1">
                  <strong>Empresa:</strong>{" "}
                  {Number(item.valorempresa).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </div>

                <div className="mb-1">
                  <strong>Em Aberto:</strong>{" "}
                  {Number(item.valorrestante).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </div>

                <div className="text-muted small">
                  <strong>Vendedor:</strong> {item.vendedor}
                </div>
              </div>
            </div>
          ))}

          <small className="text-muted">
            Registros: {listaHistorico.length}
          </small>
        </div>
      </div>

      {/* BOTÃO */}
      <div className="row mt-4">
        <div className="col-12 col-md-3 ms-md-auto">
          <button
            className="btn btn-danger w-100"
            onClick={() => navigate("/home")}
          >
            <i className="fa fa-times me-2"></i> Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default CadCliente;
